import axios from 'axios';
import { ProductInformation } from 'types';

export const fetchProductInformation = (brandId: number, productId: number) => {
  return axios.get<ProductInformation>(
    `/api/brands/${brandId}/products/${productId}/information`
  );
};
